export class Control {
  type: string;
  controlName: string;
  placeholder: string;
}
